export default __webpack_public_path__ + "static/media/first.72d3af63.jpg";